import './App.css';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import AboutMe from './components/About/AboutMe';
import ServicesMe from './components/Services/ServicesMe';
import Skills from './components/Skills/Skills';
import WorkMe from './components/Work/WorkMe';
import EducationMe from './components/Education/EducationMe';
import BlogMe from './components/Blog/BlogMe';
import FormMe from './components/Form/FormMe';
import FooterMe from './components/Footer/FooterMe';
import 'flowbite';

const  Home =() => {
    return ( 
      <>
      <Navbar />
      <Hero />
      <AboutMe />
      <ServicesMe />
      <Skills />
      <WorkMe />
      <EducationMe />
      <BlogMe />
      <FormMe />
      <FooterMe />
      </>
    );
}

export default Home;